
      import Vue from 'vue'
      import axios from 'axios'

      Vue.config.silent = true

      const hostname = window.location.hostname
      const domain = hostname.slice(hostname.indexOf('.') + 1)
      const env =
        (domain === 'qmai.cn' && 'master') ||
        (domain === 'qmai.com' && 'master') ||
        (domain === 'qimai.shop' && 'test') ||
        (domain === 'qmai.co' && 'beta') ||
        (domain === 'zmcms.cn' && 'dev') ||
        (domain === 'sgp.qimai.shop' && 'test')

      let httpHost = 'https://webapi.' + domain

      if (env !== 'master' || window.location.href.includes('enableVConsole=1')) {
        const VConsole = require('vconsole')
        new VConsole()
      }

      const storeId = window.storeId || window.localStorage.getItem('storeId') || ''
      const sourceType = window.sourceType || window.localStorage.getItem('sourceType') || ''
      
      if (!storeId) {
        throw new Error('店铺ID为空，请检查URL中是否存在store_id，或者缓存中是否存在storeId')
      }

      if (window.location.href.includes('inth5')) {
        httpHost = 'https://webapiga.' + (domain === 'qmai.com' ? 'qmai.cn' : domain)
      }

      console.log(httpHost)

      const STORE_PREFIX = storeId + '_'

      const storeName = window.storeName || window.localStorage.getItem(STORE_PREFIX + 'storeName') || ''
      const weChatOfficialAccountAppid = window.weChatOfficialAccountAppid || window.localStorage.getItem(STORE_PREFIX + 'weChatOfficialAccountAppid') || ''
      let url = httpHost + '/web/iot-center/ext-info/detail?sellerId=' + storeId
      if (sourceType) {
        url = httpHost + '/web/iot-center/ext-info/detail?sellerId=' + storeId + '&sourceType='+sourceType
      }
      axios({
        method: 'get',
        url: url,
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(response => {
          window.extConfig = Object.assign(response.data.data, {
            appName: storeName,
            storeId: storeId,
            appid: weChatOfficialAccountAppid,
          })
          // 保留 index.html 中按品牌预设的配置，extConfig 中的值优先级更高
          window.__mapConfig = Object.assign(window.__mapConfig || {}, {
            googleMapKey: window.extConfig.googleMapKey || (window.__mapConfig && window.__mapConfig.googleMapKey) || '',
          })
          import("./app.mpx?isApp").then(({ default: App }) => {
            new Vue({
              el: '#app',
              render: function(h){
                return h(App)
              }
            })
          })
        })
        .catch(error => {
          console.log(error)
        })
      

      